import { Translation } from "../hooks/useTranslations";

const es: Translation = {
  languageCode: "es",
  projects: {
    addTo: "Agregar al proyecto",
    all: "Todos los proyectos",
    new: "Nuevo proyecto",
    singular: "Proyecto",
    plural: "Proyectos",
    my: "Mis Proyectos",
    createNew: "Crear nuevo proyecto",
    infos: "Información del proyecto",
    delete: "Eliminar proyecto",
    removeShared: "Quitar proyecto compartido",
    search: "Buscar proyectos",
    shareWithUser: "Compartir proyecto con usuario",
    allowUserToEditSharedConfiguration: "Permitir que el usuario edite la configuración compartida",
    allowUserToEditSharedProjectAndConfigurations:
      "Permitir que el usuario edite el proyecto compartido y las configuraciones que contiene",
    editSharings: "Editar comparticiones",
    invitation: "Invitación al proyecto",
    invitations: "Invitaciones al proyecto",
    invite: "Invitar al proyecto",
    sharings: "Comparticiones del proyecto",
    shared: "Proyecto compartido",
    sentAt: "Enviado",
    resendInvite: "Reenviar invitación",
    invitePage: {
      badge: "Invitacion de acceso al proyecto",
      loadingProjectDetails: "Cargando detalles del proyecto...",
      collaborationLead: "te ha invitado a colaborar en este proyecto y revisar su contenido compartido.",
      projectName: "Nombre del proyecto",
      inviteNoLongerAvailable: "Esta invitacion ya no esta disponible porque ya fue aceptada, rechazada o cancelada.",
      acceptSignedIn: "Aceptar esta invitacion abrira el proyecto inmediatamente.",
      acceptSignedOut: "Aceptar esta invitacion te pedira iniciar sesion antes de concederte acceso al proyecto.",
      inviteNotFound:
        "Esta invitacion no se ha encontrado. Puede que haya sido eliminada o que el enlace sea incorrecto.",
    },

    invitationStatus: {
      pending: "Pendiente",
      active: "Activa",
      accepted: "Aceptada",
      rejected: "Rechazada",
      cancelled: "Cancelada",

      statusChanges: {
        rejected: "Invitación rechazada. Tu dirección de correo ha sido anonimizada y eliminada de este proyecto.",
        accept: "Invitación aceptada correctamente",
      },
    },

    questions: {
      delete: "Realmente deseas eliminar este proyecto?",
      unshare: "Realmente deseas dejar de compartir el proyecto con este usuario?",
      cancelInvite: "Realmente deseas cancelar esta invitación pendiente?",
      removeShared:
        "¿Realmente deseas quitar este proyecto de tus proyectos compartidos? Perderás el acceso a él y esta acción no se puede deshacer. El proyecto y sus configuraciones no se verán afectados.",
    },

    errors: {
      deleteProjectWithConfigurationsNotPossible:
        "No es posible eliminar un proyecto si hay configuraciones presentes.",
      deleteProjectWithDocumentsNotPossible: "No es posible eliminar un proyecto si hay documentos presentes.",
      notFound: "Proyecto no encontrado.",
      sharingNotFound: "Compartición no encontrada.",
      sharingAlreadyExists: "Este proyecto ya esta compartido con este usuario.",
      inviteUpdateNotAllowed: "No tienes permiso para aceptar o rechazar esta invitacion.",
      inviteAlreadyExists: "Ya existe una invitacion para este usuario.",
      inviteAlreadyCancelled: "Esta invitacion ya ha sido cancelada.",
      inviteAlreadyAccepted: "Esta invitacion ya ha sido aceptada.",
      inviteAlreadyRejected: "Esta invitacion ya ha sido rechazada.",
      documentNotFound: "Documento no encontrado.",
      missingDocumentName: "Falta el nombre del documento.",
      documentAlreadyPresent: "Documento ya presente.",
      missingProjectStatus: "Falta el estato del proyecto.",
    },
  },

  configurations: {
    all: "Todas las configuraciones",
    new: "Nueva configuración",
    plural: "Configuraciones",
    create: "Crear configuración",
    createNew: "Crear nueva configuración",
    delete: "Eliminar configuración",
    removeShared: "Quitar configuración compartida",
    duplicate: "Duplicar configuración",
    addToProject: "Añadir a proyecto",
    unlinkFromProject: "Desvincular del proyecto",
    my: "Mis configuraciones",
    search: "Buscar configuraciones",
    reset: "Restablecer configuración",

    questions: {
      delete: "¿Realmente deseas eliminar esta configuración?",
      reset: "¿Realmente deseas restablecer todos los datos de la configuración actual?",
      unlinkFromProject: "¿Realmente deseas desvincular esta configuración de su proyecto?",
      removeShared:
        "¿Realmente deseas quitar esta configuración de tus configuraciones compartidas? Perderás el acceso a ella y esta acción no se puede deshacer. La configuración no se verá afectada.",
    },

    invitePage: {
      badge: "Invitacion de acceso a la configuracion",
      loadingConfigurationDetails: "Cargando detalles de la configuracion...",
      collaborationLead: "te ha invitado a colaborar en esta configuracion y revisar su contenido compartido.",
      configurationName: "Nombre de la configuracion",
      inviteNoLongerAvailable: "Esta invitacion ya no esta disponible porque ya fue aceptada, rechazada o cancelada.",
      acceptSignedIn: "Aceptar esta invitacion abrira la configuracion inmediatamente.",
      acceptSignedOut:
        "Aceptar esta invitacion te pedira iniciar sesion antes de concederte acceso a la configuracion.",
      inviteNotFound:
        "Esta invitacion no se ha encontrado. Puede que haya sido eliminada o que el enlace sea incorrecto.",
    },

    invitationStatus: {
      statusChanges: {
        rejected: "Invitación rechazada. Tu dirección de correo ha sido anonimizada y eliminada de esta configuración.",
        accept: "Invitación aceptada correctamente",
      },
    },

    errors: {
      notFound: "Configuración no encontrada.",
      missingNormative: "Falta la normativa de la configuración.",
      missingSteelVersion: "Falta la versión del acero de la configuración.",
      missingUpperSupportInstallationType: "Falta el tipo de instalación de soporte superior de la configuración.",
      missingUpperSupport: "Falta la soporte superior de la configuración.",
      missingAbsorber: "Falta el absorvedor de la configuración.",
      missingSystemType: "Falta el tipo de sistema de la configuración.",
      missingCable: "Falta el cable de la configuración.",
      alreadyLinkedToProject: "Esta configuración ya está vinculada a un proyecto.",
      notLinkedToProject: "Esta configuración no está vinculada a un proyecto.",
    },
  },

  documents: {
    add: "Añadir documento",
    all: "Todos los documentos",
    alreadyPresent: "Documento ya presente.",
    plural: "Documentos",
    delete: "Eliminar documento",
    search: "Buscar documentos",

    questions: {
      delete: "¿Realmente deseas eliminar este documento?",
      overwrite: "¿Quieres sobrescribir el documento ya presente?",
    },

    errors: {
      someCouldNotBeSaved: "Algunos documentos no se pudieron guardar.",
    },
  },

  systems: {
    all: "Todos los sistemas",
    new: "Nuevo sistema",
    singular: "Sistema",
    plural: "Sistemas",
    delete: "Eliminar sistema",
    search: "Buscar sistemas",
    our: "Nuestros sistemas",

    questions: {
      delete: "¿Realmente deseas eliminar este sistema?",
    },

    errors: {
      notFound: "Sistema no encontrado.",
      inUseByConfiguration: "El sistema aún está en uso por una configuración.",
    },
  },

  entityAccesses: {
    title: "Permisos de usuario",
    add: "Agregar permiso de usuario",
    accessColumn: "Acceso",
    questions: {
      remove: "¿Realmente deseas eliminar el acceso de este usuario?",
    },
    errors: {
      alreadyExists: "Este usuario ya tiene un permiso para este elemento.",
    },
  },

  users: {
    add: "Agregar usuario",
    all: "Todos los usuarios",
    iam: {
      label: "IAM",
      missing: "Falta",
      valid: "Válido",
    },
    invite: "Invitar usuario",
    plural: "Usuarios",
    remove: "Eliminar usuario",
    search: "Buscar usuarios",
    usersEmail: "Correo electrónico de los usuarios",
    usersName: "Nombre de los usuarios",

    questions: {},

    errors: {
      notFound: "Usuario no encontrado.",
      notFoundInAccounts: "Usuario no encontrado en accounts.",
    },
  },

  items: {
    all: "Todos los ítems",
    singular: "Ítem",
    plural: "Ítems",
    createNew: "Crear nuevo ítem",
    delete: "Eliminar ítem",
    search: "Buscar ítems",
    list: "Lista de ítems",

    questions: {
      delete: "¿Realmente deseas eliminar este ítem?",
    },

    errors: {
      notFound: "Artículo no encontrado.",
      doesNotExist: "El artículo con este código no existe",
      missingCode: "Falta el código del artículo.",
    },
  },

  absorbers: {
    singular: "Absorbedor",
    plural: "Absorbedores",
    createNew: "Crear nuevo absorbedor",
    delete: "Eliminar absorbedor",
    edit: "Editar absorbedor",
    search: "Buscar absorbedores",
    removeFromSystem: "Eliminar absorbedor del sistema",

    questions: {
      delete: "¿Realmente deseas eliminar este absorbedor?",
      removeFromSystem: "¿Realmente deseas eliminar este absorbedor del sistema?",
    },

    errors: {
      alreadyPresent: "El absorbedor ya está presente.",
      notFound: "Absorbedor no encontrado.",
      noDefined: "No hay absorbedores definidos.",
      inUseByConfiguration: "El absorbedor aún está en uso por una configuración.",
    },
  },

  cables: {
    createNew: "Crear nuevo cable",
    delete: "Eliminar cable",
    edit: "Editar cable",
    search: "Buscar cables",
    singular: "Cable",
    plural: "Cables",

    questions: {
      delete: "¿Realmente deseas eliminar este cable?",
    },

    errors: {
      alreadyPresent: "El cable ya está presente.",
      notFound: "Cable no encontrado.",
      noDefined: "No hay cables definidos.",
      inUseByConfiguration: "El cable aún está en uso por una configuración.",
    },
  },

  handles: {
    addItemAsVertigrip: "Agregar ítem como manija Vertigrip",
    delete: "Eliminar manija",
    edit: "Editar manija",
    singular: "Manija",
    plural: "Manijas",
    search: "Buscar manijas",
    noHandle: "No hay manija",

    questions: {
      delete: "¿Realmente deseas eliminar esta manija?",
    },

    errors: {
      alreadyPresent: "La manija ya está presente.",
      notFound: "Manija no encontrada.",
      inUseByConfiguration: "La manija aún está en uso por una configuración.",
      inUseByUpperExtension: "La manija aún está en uso por una extensión superior.",
    },
  },

  intermediateElements: {
    createNew: "Crear nuevo elemento intermedio",
    delete: "Eliminar elemento intermedio",
    edit: "Editar elemento intermedio",
    singular: "Elemento intermedio",
    plural: "Elementos intermedios",
    search: "Buscar elementos intermedios",

    questions: {
      delete: "¿Realmente deseas eliminar este elemento intermedio?",
    },

    errors: {
      alreadyPresent: "El elemento intermedio ya está presente.",
      notFound: "Elemento intermedio no encontrado.",
      inUseByConfiguration: "El elemento intermedio aún está en uso por una configuración.",
    },
  },

  ladderReinforcements: {
    createNew: "Crear nuevo refuerzo de escalera",
    delete: "Eliminar refuerzo de escalera",
    edit: "Editar refuerzo de escalera",
    singular: "Refuerzo de escalera",
    plural: "Refuerzos de escalera",
    search: "Buscar refuerzos de escalera",
    noLadderReinforcement: "No hay refuerzo de escalera",

    questions: {
      delete: "¿Realmente deseas eliminar este refuerzo de escalera?",
    },

    errors: {
      alreadyPresent: "El refuerzo de escalera ya está presente.",
      notFound: "Refuerzo de escalera no encontrado.",
      inUseByConfiguration: "El refuerzo de escalera aún está en uso por una configuración.",
    },
  },

  wallMaterials: {
    createNew: "Crear nuevo material de pared",
    delete: "Eliminar material de pared",
    singular: "Material de pared",
    plural: "Materiales de pared",
    search: "Buscar materiales de pared",
    noWallMaterial: "No hay material de pared",

    questions: {
      delete: "¿Realmente deseas eliminar este material de pared?",
    },

    errors: {
      notFound: "Material de pared no encontrado.",
      inUseByConfiguration: "El material de pared aún está en uso por una configuración.",
    },
  },

  wallMaterialFixings: {
    createNew: "Crear nueva fijación",
    delete: "Eliminar fijación",
    singular: "Fijación",
    plural: "Fijaciones",
    search: "Buscar fijaciones",

    questions: {
      delete: "¿Realmente deseas eliminar esta fijación?",
    },

    errors: {
      notFound: "Fijación no encontrada.",
      inUseByConfiguration: "La fijación aún está en uso por una configuración.",
    },
  },

  wallMaterialFixingItems: {
    errors: {
      alreadyPresent: "Fijación ya presente.",
    },
  },

  lowerElements: {
    createNew: "Crear nuevo elemento inferior",
    delete: "Eliminar elemento inferior",
    edit: "Editar elemento inferior",
    singular: "Elemento inferior",
    plural: "Elementos inferiores",
    search: "Buscar elementos inferiores",

    questions: {
      delete: "¿Realmente deseas eliminar este elemento inferior?",
    },

    errors: {
      alreadyPresent: "El elemento inferior ya está presente.",
      notFound: "Elemento inferior no encontrado.",
      inUseByConfiguration: "El elemento inferior aún está en uso por una configuración.",
    },
  },

  shuttles: {
    addItemAsVertigrip: "Agregar ítem como shuttle Vertigrip",
    addItemAsPatrol: "Agregar ítem como shuttle Patrol",
    delete: "Eliminar shuttle",
    edit: "Editar shuttle",
    singular: "Shuttle",
    plural: "Shuttles",
    search: "Buscar shuttles",
    no: "No hay shuttle",

    questions: {
      delete: "¿Realmente deseas eliminar este shuttle?",
    },

    errors: {
      alreadyPresent: "El shuttle ya está presente.",
      notFound: "Shuttle no encontrado.",
      inUseByConfiguration: "El shuttle aún está en uso por una configuración.",
    },
  },

  installationTypes: {
    plural: "Tipos de instalación",
    singular: "Tipo de instalación",
    search: "Buscar tipos de instalación",

    questions: {
      delete: "¿Realmente deseas eliminar este tipo de instalación?",
    },

    errors: {
      notFound: "Tipo de instalación no encontrado.",
      inUseByConfiguration: "El tipo de instalación aún está en uso por una configuración.",
      inUseByUpperExtension: "El tipo de instalación aún está en uso por una extensión superior.",
      inUseByLowerElement: "El tipo de instalación aún está en uso por un elemento inferior.",
      inUseByIntermediateElement: "El tipo de instalación aún está en uso por un elemento intermedio.",
      inUseByLadderReinforcement: "El tipo de instalación aún está en uso por un refuerzo de escalera.",
    },
  },

  steelVersions: {
    createNew: "Crear nueva versión de acero",
    delete: "Eliminar versión de acero",
    singular: "Versión de acero",
    plural: "Versiones de acero",
    search: "Buscar versiones de acero",

    questions: {
      delete: "¿Realmente deseas eliminar esta versión de acero?",
    },

    warnings: {
      deleteWarning: "¡Advertencia! Esta acción eliminará la versión de acero y todos sus datos asociados.",
      editWarning: "¡Advertencia! La edición puede afectar a las configuraciones existentes.",
    },

    errors: {
      notFound: "Versión de acero no encontrada.",
      inUseByConfiguration: "La versión de acero aún está en uso por una configuración.",
      inUseByUpperExtension: "La versión de acero aún está en uso por una extensión superior.",
      inUseByLowerElement: "La versión de acero aún está en uso por un elemento inferior.",
      inUseByIntermediateElement: "La versión de acero aún está en uso por un elemento intermedio.",
      inUseByAsorber: "La versión de acero aún está en uso por un absorbedor.",
      inUseBySupport: "La versión de acero todavía está en uso por un soporte.",
      inUseByCurvesIntermediate: "La versión de acero todavía está en uso por una curva/intermedio.",
      inUseByTerminal: "La versión de acero todavía está en uso por un terminal.",
      inUseByShuttle: "La versión de acero todavía está en uso por un transbordador.",
      inUseByAnchorMapping: "La versión de acero todavía está en uso por un mapeo de ancla.",
      inUseByConfigurationAnchorPoint:
        "La versión de acero todavía está en uso por un punto de anclaje de configuración.",
    },
  },

  upperExtensions: {
    createNew: "Crear nueva extensión superior",
    delete: "Eliminar extensión superior",
    edit: "Editar extensión superior",
    singular: "Extensión superior",
    plural: "Extensiones superiores",
    search: "Buscar extensiones superiores",

    questions: {
      delete: "¿Realmente deseas eliminar esta extensión superior?",
    },

    errors: {
      alreadyPresent: "Extensión superior ya presente.",
      notFound: "Extensión superior no encontrada.",
      noDefined: "No hay extensiones superiores definidas.",
      inUseByConfiguration: "La extensión superior aún está en uso por una configuración.",
    },
  },

  normatives: {
    createNew: "Crear nueva normativa",
    delete: "Eliminar normativa",
    singular: "Normativa",
    plural: "Normativas",
    search: "Buscar normativas",
    add: "Agregar normativa",

    questions: {
      delete: "¿Realmente deseas eliminar esta normativa?",
    },

    errors: {
      notFound: "Normativa no encontrada.",
      noDefined: "No hay normativas definidas.",
      inUseByConfiguration: "La normativa aún está en uso por una configuración.",
    },
  },

  systemTypes: {
    singular: "Tipo de sistema",
    plural: "Tipos de sistema",
    search: "Buscar tipos de sistema",

    questions: {
      delete: "¿Realmente deseas eliminar este tipo de sistema?",
    },

    errors: {
      notFound: "Tipo de sistema no encontrado.",
      inUseByConfiguration: "El tipo de sistema aún está en uso por una configuración.",
      inUseByShuttle: "El tipo de sistema aún está en uso por un shuttle.",
      inUseByIntermediateElement: "El tipo de sistema aún está en uso por un elemento intermedio.",
    },
  },

  texts: {
    singular: "Texto",
    plural: "Textos",
    search: "Buscar textos",

    questions: {
      delete: "¿Realmente deseas eliminar este texto?",
    },

    errors: {
      alreadyPresent: "El texto ya está presente.",
      notFound: "Texto no encontrado.",
      missingId: "Falta el ID del texto.",
      missingValue: "Falta el valor del texto.",
    },
  },

  clients: {
    all: "Todos los clientes",
    plural: "Clientes",
    createNew: "Crear nuevo cliente",
    delete: "Eliminar cliente",
    search: "Buscar clientes",

    questions: {
      delete: "¿Realmente quieres eliminar este cliente?",
    },

    errors: {
      notFound: "Cliente no encontrado.",
      insertNotAllowed: "No tienes permiso para insertar un nuevo cliente.",
      readNotAllowed: "No tienes permiso para leer a este cliente.",
      updateNotAllowed: "No tienes permiso para actualizar a este cliente.",
      deleteNotAllowed: "No tienes permiso para eliminar a este cliente.",
    },
  },

  roles: {
    plural: "Roles",
  },

  permissions: {
    plural: "Permisos",
  },

  secrets: {
    plural: "Secrets",

    errors: {
      missingValue: "Falta el valor de secret.",
    },
  },

  substructures: {
    createNew: "Crear nueva subestructura",
    delete: "Eliminar subestructura",
    singular: "Subestructura",
    plural: "Subestructuras",
    single: "Subestructura",
    search: "Buscar subestructuras",
    edit: "Editar subestructura",

    questions: {
      delete: "¿Realmente quieres eliminar esta subestructura?",
    },
  },

  bases: {
    createNew: "Crear nueva base",
    delete: "Eliminar base",
    singular: "Base",
    plural: "Bases",
    search: "Buscar bases",
    edit: "Editar base",
    add: "Agregar base",

    questions: {
      delete: "¿Realmente quieres eliminar esta base?",
    },

    errors: {
      alreadyPresent: "Base ya presente",
      notFound: "Base no encontrado",
    },
  },

  ballasts: {
    createNew: "Crear nuevo lastre",
    delete: "Eliminar lastre",
    singular: "Lastre",
    plural: "Lastres",
    search: "Buscar lastres",
    edit: "Editar lastre",
    add: "Agregar lastre",

    questions: {
      delete: "¿Realmente quieres eliminar este lastre?",
    },

    errors: {
      alreadyPresent: "Balasto ya presente",
      notFound: "Balasto no encontrado",
    },
  },

  ballastTypes: {
    createNew: "Crear nuevo tipo de lastre",
    delete: "Eliminar tipo de lastre",
    singular: "Tipo de lastre",
    plural: "Tipos de lastre",
    search: "Buscar tipos de lastre",
    edit: "Editar tipo de lastre",

    questions: {
      delete: "¿Realmente quieres eliminar este tipo de lastre?",
    },

    errors: {
      missingName: "Falta el nombre del tipo de lastre",
      notFound: "Tipo de lastre no encontrado",
    },
  },

  uprights: {
    createNew: "Crear nuevo soporte",
    delete: "Eliminar soporte",
    singular: "Soporte",
    plural: "Soportes",
    search: "Buscar soportes",
    edit: "Editar soporte",
    add: "Agregar soporte",

    questions: {
      delete: "¿Realmente deseas eliminar este soporte?",
    },

    errors: {
      alreadyPresent: "Soporte ya presente",
      notFound: "Soporte no encontrado",
    },
  },

  uprightTypes: {
    createNew: "Crear nuevo tipo de soporte",
    delete: "Eliminar tipo de soporte",
    singular: "Tipo de soporte",
    plural: "Tipos de soporte",
    search: "Buscar tipos de soporte",
    edit: "Editar tipo de soporte",
    add: "Agregar tipo de soporte",

    questions: {
      delete: "¿Realmente deseas eliminar este tipo de soporte?",
    },

    errors: {
      missingName: "El nombre del tipo de soporte es obligatorio",
      notFound: "Tipo de soporte no encontrado",
      inUseByUprights: "El tipo de soporte todavía se usa en uno o más soportes",
    },
  },

  guardrailCompositions: {
    createNew: "Crear nueva composición de barandilla",
    delete: "Eliminar composición de barandilla",
    singular: "Composición de barandilla",
    plural: "Composiciones de barandilla",
    search: "Buscar composiciones de barandilla",
    edit: "Editar composición de barandilla",
    add: "Agregar composición de barandilla",

    questions: {
      delete: "¿Realmente deseas eliminar esta composición de barandilla?",
    },

    errors: {
      missingName: "Falta el nombre de la composición de barandilla",
      notFound: "Composición de barandilla no encontrada",
    },
  },

  rails: {
    createNew: "Crear nuevo riel",
    delete: "Eliminar riel",
    singular: "Riel",
    plural: "Rieles",
    search: "Buscar rieles",
    edit: "Editar riel",
    add: "Agregar riel",

    questions: {
      delete: "¿Realmente deseas eliminar este riel?",
    },

    errors: {
      alreadyPresent: "Riel ya presente",
      notFound: "Riel no encontrado",
    },
  },

  toeBoards: {
    createNew: "Crear nuevo rodapié",
    delete: "Eliminar rodapié",
    singular: "Rodapié",
    plural: "Rodapiés",
    search: "Buscar rodapiés",
    edit: "Editar rodapié",
    add: "Agregar rodapié",

    questions: {
      delete: "¿Realmente deseas eliminar este rodapié?",
    },

    errors: {
      alreadyPresent: "Rodapié ya presente",
      notFound: "Rodapié no encontrado",
    },
  },

  toeBoardExtras: {
    createNew: "Crear nuevo rodapié extra",
    delete: "Eliminar rodapié extra",
    singular: "Rodapié extra",
    plural: "Rodapiés extra",
    search: "Buscar rodapiés extra",
    edit: "Editar rodapié extra",
    add: "Agregar rodapié extra",

    questions: {
      delete: "¿Realmente deseas eliminar este rodapié extra?",
    },

    errors: {
      alreadyPresent: "Rodapié extra ya presente",
      notFound: "Rodapié extra no encontrado",
    },
  },

  uprightCaps: {
    createNew: "Crear nueva tapa de soporte",
    delete: "Eliminar tapa de soporte",
    singular: "Tapa de soporte",
    plural: "Tapas de soporte",
    search: "Buscar tapas de soporte",
    edit: "Editar tapa de soporte",
    add: "Agregar tapa de soporte",

    questions: {
      delete: "¿Realmente deseas eliminar esta tapa de soporte?",
    },

    errors: {
      alreadyPresent: "Tapa de soporte ya presente",
      notFound: "Tapa de soporte no encontrada",
    },
  },

  railCaps: {
    createNew: "Crear nueva tapa de riel",
    delete: "Eliminar tapa de riel",
    singular: "Tapa de riel",
    plural: "Tapas de riel",
    search: "Buscar tapas de riel",
    edit: "Editar tapa de riel",
    add: "Agregar tapa de riel",

    questions: {
      delete: "¿Realmente deseas eliminar esta tapa de riel?",
    },

    errors: {
      alreadyPresent: "Tapa de riel ya presente",
      notFound: "Tapa de riel no encontrada",
    },
  },

  railWallFixings: {
    createNew: "Crear nueva fijación de riel a pared",
    delete: "Eliminar fijación de riel a pared",
    singular: "Fijación de riel a pared",
    plural: "Fijaciones de riel a pared",
    search: "Buscar fijaciones de riel a pared",
    edit: "Editar fijación de riel a pared",
    add: "Agregar fijación de riel a pared",

    questions: {
      delete: "¿Realmente deseas eliminar esta fijación de riel a pared?",
    },

    errors: {
      alreadyPresent: "Fijación de riel a pared ya presente",
      notFound: "Fijación de riel a pared no encontrada",
    },
  },

  railCorners: {
    createNew: "Crear nueva esquina de riel",
    delete: "Eliminar esquina de riel",
    singular: "Esquina de riel",
    plural: "Esquinas de riel",
    search: "Buscar esquinas de riel",
    edit: "Editar esquina de riel",
    add: "Agregar esquina de riel",

    questions: {
      delete: "¿Realmente deseas eliminar esta esquina de riel?",
    },

    errors: {
      alreadyPresent: "Esquina de riel ya presente",
      notFound: "Esquina de riel no encontrada",
    },
  },

  gates: {
    createNew: "Crear nueva puerta",
    delete: "Eliminar puerta",
    singular: "Puerta",
    plural: "Puertas",
    search: "Buscar puertas",
    edit: "Editar puerta",
    add: "Agregar puerta",

    questions: {
      delete: "¿Realmente deseas eliminar esta puerta?",
    },

    errors: {
      alreadyPresent: "Puerta ya presente",
      notFound: "Puerta no encontrada",
    },
  },

  waterproofKits: {
    createNew: "Crear nuevo kit impermeable",
    delete: "Eliminar kit impermeable",
    singular: "Kit impermeable",
    plural: "Kits impermeables",
    search: "Buscar kits impermeables",
    edit: "Editar kit impermeable",
    add: "Agregar kit impermeable",

    questions: {
      delete: "¿Realmente deseas eliminar este kit impermeable?",
    },

    errors: {
      alreadyPresent: "Kit impermeable ya presente",
      notFound: "Kit impermeable no encontrado",
    },
  },

  fastenings: {
    singular: "Fijación",
  },

  fasteningChoices: {
    createNew: "Crear nueva combinación de fijaciones",
    delete: "Eliminar combinación de fijaciones",
    edit: "Editar combinación de fijaciones",
    singular: "Combinación de fijaciones",
    plural: "Combinaciones de fijaciones",
    search: "Buscar combinaciones de fijaciones",
    combination: "Combinación",
    factorPerUpright: "Factor por montante",

    questions: {
      delete: "¿Realmente deseas eliminar esta combinación de fijaciones?",
    },

    errors: {
      alreadyPresent: "Combinación de fijaciones ya presente",
      duplicateFastening: "Fijación duplicada seleccionada",
      notFound: "Combinación de fijaciones no encontrada",
    },
  },

  membraneProtections: {
    createNew: "Crear nueva membrana protectora",
    delete: "Eliminar membrana protectora",
    singular: "Membrana protectora",
    plural: "Membranas protectoras",
    search: "Buscar membranas protectoras",
    edit: "Editar membrana protectora",
    add: "Agregar membrana protectora",

    questions: {
      delete: "¿Realmente deseas eliminar esta membrana protectora?",
    },

    errors: {
      alreadyPresent: "Membrana protectora ya presente",
      notFound: "Membrana protectora no encontrada",
    },
  },

  workMethods: {
    singular: "Método de trabajo",
    plural: "Métodos de trabajo",
    deleteLabel: "método de trabajo",
    new: "Nuevo método de trabajo",
    edit: "Editar método de trabajo",
    delete: "Eliminar método de trabajo",
    search: "Buscar métodos de trabajo",
  },
  supports: {
    singular: "Soporte",
    plural: "Soportes",
    deleteLabel: "soporte",
    new: "Nuevo soporte",
    edit: "Editar soporte",
    delete: "Eliminar soporte",
    search: "Buscar soportes",
  },
  labelLanguages: {
    singular: "Idioma de etiqueta",
    plural: "Idiomas de etiqueta",
    deleteLabel: "idioma de etiqueta",
    new: "Nuevo idioma de etiqueta",
    edit: "Editar idioma de etiqueta",
    delete: "Eliminar idioma de etiqueta",
    search: "Buscar idiomas de etiqueta",
  },
  towers: {
    singular: "Torre",
    plural: "Torres",
    deleteLabel: "torre",
    new: "Nueva torre",
    edit: "Editar torre",
    delete: "Eliminar torre",
    search: "Buscar torres",
  },
  trolleys: {
    singular: "Carro",
    plural: "Carros",
    deleteLabel: "carro",
    new: "Nuevo carro",
    edit: "Editar carro",
    delete: "Eliminar carro",
    search: "Buscar carros",
  },
  railCurves: {
    singular: "Curva de riel",
    plural: "Curvas de riel",
    deleteLabel: "curva de riel",
    new: "Nueva curva de riel",
    edit: "Editar curva de riel",
    delete: "Eliminar curva de riel",
    search: "Buscar curvas de riel",
  },
  railJunctions: {
    singular: "Unión de riel",
    plural: "Uniones de riel",
    deleteLabel: "unión de riel",
    new: "Nueva unión de riel",
    edit: "Editar unión de riel",
    delete: "Eliminar unión de riel",
    search: "Buscar uniones de riel",
  },
  railTerminals: {
    singular: "Terminal de riel",
    plural: "Terminales de riel",
    deleteLabel: "terminal de riel",
    new: "Nuevo terminal de riel",
    edit: "Editar terminal de riel",
    delete: "Eliminar terminal de riel",
    search: "Buscar terminales de riel",
  },
  screws: {
    singular: "Tornillo",
    plural: "Tornillos",
    deleteLabel: "tornillo",
    new: "Nuevo tornillo",
    edit: "Editar tornillo",
    delete: "Eliminar tornillo",
    search: "Buscar tornillos",
  },
  tools: {
    singular: "Herramienta",
    plural: "Herramientas",
    deleteLabel: "herramienta",
    new: "Nueva herramienta",
    edit: "Editar herramienta",
    delete: "Eliminar herramienta",
    search: "Buscar herramientas",
  },
  fasteningOptions: {
    singular: "Opción de fijación",
    plural: "Opciones de fijación",
    deleteLabel: "opción de fijación",
    new: "Nueva opción de fijación",
    edit: "Editar opción de fijación",
    delete: "Eliminar opción de fijación",
    search: "Buscar opciones de fijación",
  },
  fasteningOptionItems: {
    singular: "Elemento de opción de fijación",
    plural: "Elementos de opción de fijación",
    deleteLabel: "elemento de opción de fijación",
    new: "Nuevo elemento de opción de fijación",
    edit: "Editar elemento de opción de fijación",
    delete: "Eliminar elemento de opción de fijación",
    search: "Buscar elementos de opción de fijación",
  },
  itemExtras: {
    singular: "Elemento extra",
    plural: "Extras",
    deleteLabel: "elemento extra",
    new: "Nuevo elemento extra",
    edit: "Editar elemento extra",
    delete: "Eliminar elemento extra",
    search: "Buscar extras",
  },
  supportItems: {
    singular: "Elemento de soporte",
    plural: "Elementos de soporte",
    deleteLabel: "elemento de soporte",
    new: "Nuevo elemento de soporte",
    edit: "Editar elemento de soporte",
    delete: "Eliminar elemento de soporte",
    search: "Buscar elementos de soporte",
  },
  systemSupportOptions: {
    singular: "Opción de soporte del sistema",
    plural: "Opciones de soporte del sistema",
    deleteLabel: "opción de soporte del sistema",
    new: "Nueva opción de soporte del sistema",
    edit: "Editar opción de soporte del sistema",
    delete: "Eliminar opción de soporte del sistema",
    search: "Buscar opciones de soporte del sistema",
  },

  common: {
    active: "Activo",
    accept: "Aceptar",
    add: "Agregar",
    addPoints: "Agregar puntos",
    addNewItem: "Agregar nuevo ítem",
    address: "Dirección",
    administration: "Administración",
    allow: "Permitir",
    deny: "Denegar",
    shared: "Compartido",
    canEdit: "Puede editar",
    alreadyPresent: "Ya presente",
    general: "General",
    itemDependencies: "Dependencias de artículos",
    millimeters: " mm",
    deduction: "Deducción",
    nominalAngle: "Ángulo nominal",
    deflection: "Deflexión",
    horizontalDeduction: "Deducción horizontal",
    internalDeduction: "Deducción interna",
    externalDeduction: "Deducción externa",
    doubleTerminal: "Terminal doble",
    doubleTerminalVisible: "Terminal doble visible",
    factorPerFasteningPoint: "Factor por punto de fijación",
    factorPerLabel: "Factor por etiqueta",
    fasteningOption: "Opción de fijación",
    fasteningPoints: "Puntos de fijación",
    fasteningPointsPerSupport: "Puntos de fijación por soporte",
    floor: "Suelo",
    overhead: "Suspendido",
    wall: "Pared",
    none: "Ninguno",
    required: "Requerido",
    horizontal: "Horizontal",
    vertical: "Vertical",
    terminalTypeClosed: "Cerrado",
    terminalTypeOpen: "Abierto",
    jointHoleTemplateVisible: "Plantilla de orificios de unión visible",
    jointTemplate: "Plantilla de unión",
    junctions: "Uniones",
    junctionsRequired: "Uniones requeridas",
    mountingContext: "Contexto de montaje",
    plane: "Plano",
    quantity: "Cantidad",
    quantityPerItem: "Cantidad por artículo",
    quantityPerSupport: "Cantidad por soporte",
    supportsRequired: "Soportes requeridos",
    hrailSupport: "Soporte",
    systemHeader: (title: string) => `Sistema: ${title}`,
    terminalType: "Tipo de terminal",
    tower: "Torre",
    workMethod: "Método de trabajo",
    fasteningOptionHeader: (title: string) => `Opción de fijación: ${title}`,
    deleteEntityQuestion: (entity: string, label: string) => `¿Eliminar ${entity} "${label}"?`,
    angle: "Ángulo",
    angles: "Ángulos",
    archived: "Archivado",
    atLeastOneItemNeeded: "Se necesita al menos un ítem.",
    author: "Autor",
    automaticSync: "Sincronización automática",
    baseOrientation: "Orientación base",
    cornerClassification: "Clasificación de esquina",
    bottomClamp: "Abrazadera inferior",
    bottomItems: "Elementos inferiores",
    clamped: "Fijado",
    clampThickness: "Espesor de fijación",
    curve: "Curva",
    topClamp: "Abrazadera superior",
    back: "Atrás",
    baseHeight: "Altura base",
    breadcrumb: "Ruta de navegación",
    cancel: "Cancelar",
    close: "Cerrar",
    city: "Ciudad",
    code: "Código",
    company: "Empresa",
    confirmed: "Confirmado",
    contactPerson: "Persona de contacto",
    contactPersonWarning:
      "La introducción de estos datos es voluntaria y bajo la total responsabilidad del Usuario. No se recomienda introducir datos que identifiquen o hagan identificables a las personas.",
    cookiePolicy: "Política de cookies",
    coordinates: "Coordenadas",
    copy: "Copia",
    corners: "Esquinas",
    country: "País",
    corrugationSpan: "Amplitud de ondulación",
    curb: "Bordillo",
    curbHeight: "Altura del bordillo",
    curbDepth: "Profundidad del bordillo",
    curbHeightBelowMinimum: (value: number) => `La altura mínima del bordillo para esta selección es de ${value} mm`,
    curbDepthBelowBaseHeight: (value: number) =>
      `La profundidad del bordillo debe ser de al menos ${value} mm para alojar la base seleccionada`,
    curved: "Curvado",
    create: "Crear",
    created: "Creado",
    createNew: "Crear nuevo",
    currentRoofDoesNotAllowAnchorPoints:
      "La configuración actual del techo no es adecuada para puntos de anclaje individuales.",
    dataHasBeenSavedSuccessfully: "Los datos se han guardado exitosamente.",
    date: "Fecha",
    decrease: (value: number) => `Disminuir ${value}`,
    download: "Descargar",
    delete: "Eliminar",
    description: "Descripción",
    descriptionLong: "Descripción (larga)",
    descriptionShort: "Descripción (corta)",
    diameter: "Diámetro",
    details: "Detalles",
    distance: "Distancia",
    dragAndDropOrUploadAnImage: "Arrastra y suelta o haz clic para subir una imagen",
    dropIt: "¡Suelte aquí!",
    duplicate: "Duplicar",
    edit: "Editar",
    editor: "Editor",
    email: "Correo electrónico",
    error: "Error",
    errorLoadingData: "Error al cargar los datos",
    excel: "Excel",
    failed: "Fallido",
    fieldCannotBeEmpty: "El campo no puede estar vacío.",
    fieldContainsInvalidValueInsertBiggerOne: "El campo contiene un valor inválido, inserta uno mayor.",
    fieldContainsInvalidValueInsertSmallerOne: "El campo contiene un valor inválido, inserta uno menor.",
    fieldValueInvalidFormat: "El valor tiene un formato inválido.",
    fieldInvalidValue: "El campo contiene un valor inválido.",
    fixed: "Fijo",
    forbidden: "No permitido",
    generalData: "Datos generales",
    genericError: "Ha ocurrido un error, por favor intenta de nuevo.",
    guardrailComposition: "Composición de barandilla",
    heightToReach: "Altura a alcanzar",
    hidden: "Oculto",
    home: "Inicio",
    increase: (value: number) => `Aumentar ${value}`,
    installed: "Instalado",
    intermediateSupport: "Soporte intermedia",
    isVisible: "Es visible",
    isBallastRequired: "Se requiere lastre",
    isFasteningVisible: "La fijación es visible",
    isGateVisible: "La puerta es visible",
    isHighWindVisible: "Alta resistencia al viento visible",
    isIntermediateBarRequired: "Se requiere barra intermedia",
    isSubstructureRequired: "Se requiere subestructura",
    isSubstructureDetailsRequired: "Detalles de la subestructura requeridos",
    isPerimeterSplitRequired: "División del perímetro requerida",
    isCornerOrientationRequired: "Orientación de las esquinas requerida",
    isReclinableUpright: "Es abatible",
    isCurbVisible: "Bordillo visible",
    isCurbDepthVisible: "Profundidad del bordillo visible",
    isReinforced: "Está reforzado",
    isToeBoardRequired: "Se requiere rodapié",
    isVertical: "Es vertical",
    isVerticalBaseTypeRequired: "Se requiere un tipo de base vertical",
    isWaterproofKitVisible: "El kit de impermeabilización es visible",
    isWedgeVisible: "La cuña es visible",
    visibility: "Visibilidad",
    rothoblaasUsers: "Usuarios Rothoblaas",
    externalUsers: "Usuarios externos",
    everyOne: "Todos",
    ladderExitDifference: "Diferencia salida escalera",
    translations: "Traducciones",
    appLanguage: "Idioma de la aplicación",
    languages: {
      singular: "Idioma",
      plural: "Idiomas",
      arabic: "Árabe",
      czech: "Checo",
      danish: "Danés",
      german: "Alemán",
      greek: "Griego",
      english: "Inglés",
      spanish: "Español",
      estonian: "Estonio",
      finnish: "Finés",
      french: "Francés",
      croatian: "Croata",
      hungarian: "Húngaro",
      icelandic: "Islandés",
      italian: "Italiano",
      japanese: "Japonés",
      lithuanian: "Lituano",
      latvian: "Letón",
      dutch: "Neerlandés",
      norwegian: "Noruego",
      polish: "Polaco",
      portugese: "Portugués",
      russian: "Ruso",
      slovak: "Eslovaco",
      slovenian: "Esloveno",
      swedish: "Sueco",
      turkish: "Turco",
      chinese: "Chino",
      korean: "Coreano",
    },
    firstName: "Nombre",
    lastAccess: "Último acceso",
    lastModified: "Última modificación",
    lastName: "Apellido",
    lastSync: "Última sincronización",
    left: "Izquierda",
    loading: "Cargamento...",
    location: "Ubicación",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    lowerSupport: "Soporte inferior",
    lowerHoleDiameter: "Diámetro del agujero inferior",
    minimumConfigurableQuantity: "Cantidad mínima configurable",
    minimumOrderQuantity: "Cantidad mínima de pedido",
    minOrderQuantity: "Cant. mín. pedido",
    myArea: "Mi área",
    myProfile: "Mi perfil",
    name: "Nombre",
    next: "Siguiente",
    never: "nunca",
    newConfigurationName: "Nuevo nombre configuración",
    nextNRows: (n: number) => `Siguientes ${n} filas`,
    no: "No",
    noItemsFound: "No ítems encontrados",
    notFound: "No encontrado",
    nrBallastIntermediate: "Nº de lastres intermedios",
    nrBallastTerminal: "Nº de lastres terminales",
    writePermissions: "Permisos de escritura",
    permissionToEdit: "Permiso para editar",
    nrIntermediatesAndSpan: "Nº de intermedios y tramo",
    nrRivets: "Nº de remaches",
    nrOfFixingItemsRequired: "Número de elementos de fijación requeridos (por material de pared)",
    offer: "Oferta",
    ok: "Ok",
    onlyImagesAreAllowed: "Solo se permiten imágenes.",
    open: "Abrir",
    optional: "opcional",
    order: "Orden",
    overwrite: "Sobrescribir",
    previousNRows: (n: number) => `Filas anteriores ${n}`,
    print: "Imprimir",
    privacyPolicy: "Política de privacidad",
    qty: "Cant.",
    reject: "Rechazar",
    removable: "Removible",
    rename: "Renombrar",
    reclining: "Abatible",
    remove: "Eliminar",
    removeImage: "Eliminar imagen",
    reinforcedRailRequired: "Riel reforzado requerido",
    reset: "Restablecer",
    resetToDefault: "Restablecer a los valores predeterminados",
    resourceNotFound: "El recurso que buscas no se ha encontrado.",
    save: "Guardar",
    saved: "Guardado",
    draft: "Borrador",
    search: "Buscar",
    select: "Selecciona",
    selectProject: "Seleccionar proyecto",
    selectProjectFirst: "Selecciona un proyecto primero",
    selectProjectInwhichCreateCopy: "Seleccione el proyecto en el que crear la copia",
    sessionExpired: "Sesión expirada",
    sessionExpiredText: "Por favor, inicia sesión de nuevo para continuar usando la aplicación.",
    settings: "Configuraciones",
    status: "Estado",
    sync: "Sincronizar",
    targa: "Targa",
    testEnvironment: "Entorno de prueba",
    toBeInstalled: "Por instalar",
    toInspect: "Por inspeccionar",
    uploadedAt: "Subido",
    uploadedBy: "Subido por",
    upperSupport: "Soporte superior",
    upperHoleDiameter: "Diámetro del agujero superior",
    value: "Valor",
    visible: "Visible",
    yes: "Sí",
    youAreNotAllowed: "No estás autorizado para acceder a este recurso.",
    youCannotMixUpSubstructureHeightSizeAndThickness:
      "No se puede mezclar la altura de la subestructura, el tamaño y el grosor de la placa metálica.",
    youCannotMixUpSubstructureMaxSpanAndMaxInsulationThickness:
      "No se puede mezclar la luz máxima de la subestructura y el grosor máximo del aislamiento.",
    canBeCustom: "Puede ser personalizado",
    canBeMultiple: "Puede ser múltiple",
    categories: "Categorías",
    codeItem: "Código del elemento",
    codeExtraItem: "Código del elemento extra",
    components: "Componentes",
    curves: "Curvas",
    draw: "Dibujar",
    excludedItems: "Elementos excluidos",
    extensions: "Extensiones",
    extras: "Extras",
    flatRoofCompatible: "Compatible con techo plano",
    hasHips: "Tiene caballetes",
    height: "Altura",
    image: "Imagen",
    hipLength: "Longitud del caballete",
    hipsSpan: "Luz del caballete",
    hipsSpanRequired: "Luz del caballete requerida",
    insulationThickness: "Espesor del aislamiento",
    insulationThicknessRequired: "Espesor del aislamiento requerido",
    intermediates: "Intermedios",
    isFlat: "Es plano",
    isLifeLine: "Es línea de vida",
    length: "Longitud",
    loop: "Bucle",
    mappings: "Asignaciones",
    max: "Máximo",
    maxInsulationThickness: "Espesor máximo del aislamiento",
    maxPitch: "Pendiente máxima",
    maxSpan: "Luz máxima",
    maxThickness: "Espesor máximo",
    maxUsers: "Usuarios máximos",
    min: "Mínimo",
    minMetalPlateThickness: "Espesor mínimo de placa metálica",
    minSubstructureHeight: "Altura mínima de subestructura",
    minSubstructureSize: "Tamaño mínimo de subestructura",
    minThickness: "Espesor mínimo",
    minCurbHeight: "Altura mínima del bordillo",
    minHeight: "Altura mínima",
    minSpan: "Luz mínima",
    minValue: "Valor mínimo",
    minWidth: "Anchura mínima",
    notLoop: "No bucle",
    notRightAngle: "No ángulo recto",
    nrOfShuttlesForLifeLines: "Número de shuttles para líneas de vida",
    nrOfShuttlesRequestted: "Número de shuttles solicitados",
    perimeter: "Perímetro",
    closedPerimeter: "Perímetro cerrado",
    perimeterLength: "Longitud total del perímetro",
    perimeterLengthParallel: "Longitud paralela a la onda",
    perimeterLengthPerpendicular: "Longitud perpendicular a la onda",
    cornerCountTotal: "Número total de esquinas",
    cornerCountInternal: "Número de esquinas internas",
    cornerCountExternal: "Número de esquinas externas",
    parallel: "Paralelo",
    perpendicular: "Perpendicular",
    internal: "Interno",
    external: "Externo",
    pitch: "Pendiente",
    pleaseSpecifyAHeight: "Por favor, especifique una altura",
    pleaseSpecifyAWidth: "Por favor, especifique una anchura",
    pleaseSpecifyHeightAndWidth: (height: number, width: number, unit: string) =>
      `Por favor, especifique (altura)x(anchura): ${height}x${width} ${unit}`,
    rightAngle: "Ángulo recto",
    right: "Derecha",
    roof: "Techo",
    roofInfo: "Información del techo",
    roofs: "Techos",
    roofWeight: "Peso del techo",
    roofWeightRequired: "Peso del techo requerido",
    seamHeight: "Altura de costura",
    seamHeightRequired: "Altura de costura requerida",
    seamsSpan: "Luz de costuras",
    seamsSpanRequired: "Luz de costuras requerida",
    sheetMaterialRequired: "Material de chapa requerido",
    span: "Luz",
    stepHeightRequired: "Altura de escalón requerida",
    straight: "Recto",
    substructureHeight: "Altura de subestructura",
    substructures: "Subestructuras",
    substructureSize: "Tamaño de subestructura",
    supports: "Soportes",
    supportHeight: "Altura del soporte",
    supportMaterialRequired: "Material de soporte requerido",
    supportSelection: "Selección de soporte",
    type: "Tipo",
    types: "Tipos",
    caps: "Tapas",
    useOnlyAnchorPoints: "Usar solo puntos de anclaje",
    wallFixings: "Fijaciones a pared",
    waveSpan: "Luz de onda",
    waveSpanRequired: "Luz de onda requerida",
    width: "Anchura",
    componentMaterial: "Material del componente",
    componentMaterials: "Materiales de componentes",
    lifeLineAnchors: "Anclajes de línea de vida",
    absorberAllowsMaxNUsers: (n: number) => `El absorbedor permite máximo ${n} usuarios`,
    metalPlateThickness: "Espesor de placa metálica",
    supportIntermediateElement: "Elemento intermedio de soporte",
    supportIntermediateElements: "Elementos intermedios de soporte",
    supportTerminalCurve: "Curva terminal de soporte",
    extraItem: "Elemento extra",
    forLoop: "Para bucle",
    forNotLoop: "Para no bucle",
    invitationHasBeenSentSuccessfully: "Invitación ha sido enviada exitosamente.",
    invite: "Invitar",
    invitePage: {
      fallbackAuthorName: "un miembro del equipo",
      invitedBy: "Invitado por",
      invitationSentTo: "Invitacion enviada a",
      description: "Descripcion",
      notAvailable: "No disponible",
      acceptAction: "Aceptar invitacion",
      rejectAction: "Rechazar invitacion",
      notFoundTitle: "Invitacion no encontrada",
    },
    isAnchorPoint: "Es punto de anclaje",
    stepHeight: "Altura de escalón",
    default: "Predeterminado",
    defaultPitch: "Pendiente predeterminada",
    degrees: "Grados",
    editCurve: "Editar curva",
    editPatrolComponent: "Editar componente Patrol",
    editTerminal: "Editar terminal",
    erease: "Borrar",
    factor: "Factor",
    finish: "Finalizar",
    forTerminalsAndCurves: "Para terminales y curvas",
    forIntermediates: "Para intermedios",
    globalSettings: "Configuración global",
    help: "Ayuda",
    hide: "Ocultar",
    hipsSpans: "Luces de caballetes",
    includeSelectedComponent: "Incluir componente seleccionado",
    includeTarga: "Incluir Targa",
    intermediate: "Intermedio",
    intersectionPoint: "Punto de intersección",
    isClampable: "Es fijable",
    isSubstructureIndependent: "Es independiente de la subestructura",
    lifeLine: "Línea de vida",
    lifeLinePlusAnchorPoint: "Línea de vida + punto de anclaje",
    lifeLinesAndAnchorPointsHaveBeenFound_message:
      "Se han encontrado líneas de vida y puntos de anclaje. Para editar la configuración del techo, debe eliminar estos datos. Haga clic en 'Eliminar' para eliminarlos y liberar el formulario",
    lifeLineSegment: "Segmento de línea de vida",
    maxAngle: "Ángulo máximo",
    maxCornersPerLifeline: "Esquinas máximas por línea de vida",
    maxHeight: "Altura máxima",
    maxSeamsSpan: "Luz máxima entre costuras",
    maxSpanBetweenCurveAndIntermediate: "Luz máxima entre curva e intermedios",
    maxSpanBetweenIntermediate: "Luz máxima entre intermedios",
    minAngle: "Ángulo mínimo",
    minSpanBetweenSupports: "Luz mínima entre soportes",
    minPitch: "Pendiente mínima",
    noAdditionalPost: "Sin poste adicional",
    normativeDetails: "Detalles normativos",
    onlyAnchorPoint: "Solo punto de anclaje",
    onlyFor: "Solo para",
    onlyLifeLine: "Solo línea de vida",
    optionals: "Opcionales",
    pitchMinMaxDefault: "Pendiente (min/max/predeterminado)",
    pleaseSpecifyAMaxHeight: "Por favor, especifique una altura máxima",
    pleaseSpecifyAMinHeight: "Por favor, especifique una altura mínima",
    pleaseSpecifyAValueBetween: (min: number, max: number | null, unit: string | null) =>
      (max
        ? `Por favor, especifique un valor entre ${min} y ${max}`
        : `Por favor, especifique un valor mayor que ${min}`) + (unit ? ` ${unit}` : "").trim(),
    searchIntermediatedCurves: "Buscar intermedios/curvas",
    selectedComponent: "Componente seleccionado",
    show: "Mostrar",
    spans: "Luces",
    splitLifeLineHere: "Dividir línea de vida aquí",
    stepHeightRange: "Rango de altura de escalón",
    support: "Soporte",
    supportCurve: "Soporte de curva",
    supportTerminal: "Soporte de terminal",
    supportTerminalAndCurve: "Soporte de terminal y curva",
    terminal: "Terminal",
    terminal_plus_intermediate: "Terminal + intermedio",
    terminalAndCurve: "Terminal y curva",
    terminalCurves: "Terminales/curvas",
    terminalCurveAndIntermediate: "Terminal, curva e intermedio",
    termsAndConditions: "Términos y Condiciones",
    theMaximumAllowedValueIs: (value: number) => `El valor máximo permitido es ${value}°`,
    theMaximulAllowedLifeLineLengthExceeds: (
      meters: number,
      curves: number,
      maxLength: number,
      allowedLength: number,
    ) =>
      `La línea de seguridad del segmento seleccionado tiene una longitud de ${meters} metros. Debido a las ${curves} curvas, la longitud máxima permitida de ${maxLength} metros se reduce a ${allowedLength}. Por favor, divida la línea.`,
    theMinAngleOfCurveForTheSystemIs_degrees: (degrees: number) =>
      `El sistema seleccionado no permite curvas con un ángulo menor a ${degrees}°`,
    theMinAngleIfIntermediateAndTerminalforTheSystemIs_degrees: (degrees: number) =>
      `El sistema seleccionado con intersección (terminal e intermedia) solo permite una línea casi recta (mínimo ${degrees}°).`,
    theMinimumAllowedValueIs: (value: number) => `El valor mínimo permitido es ${value}°`,
    theSystemRequiresAMinSpanOfXMeters: (minSpan: number) =>
      `El sistema requiere una distancia mínima de ${minSpan} metros`,
    topExtraItem: "Elemento extra superior",
    topItem: "Elemento superior",
    unlock: "Desbloquear",
    unshare: "Dejar de compartir",
    update: "Actualizar",
    versions: "Versiones",
    warningThisEditCouldAffectOtherSystemsAsWell: "Advertencia: esta edición podría afectar también a otros sistemas",
    from: "Desde",
    meters: "Metros",
    terminal_plus_terminal: "Terminal+terminal",
    to: "Hasta",
    defaultSupports: "Soportes por defecto",
    supportRequired: "Soporte requerido",
    supportsHeight: "Altura de los soportes",
  },
  elements: {
    createNew: "Crear nuevo elemento",
    delete: "Eliminar elemento",
    edit: "Editar elemento",
    singular: "Elemento",
    plural: "Elementos",
    search: "Buscar elementos",
    questions: {
      delete: "¿Realmente deseas eliminar este elemento?",
    },
    errors: {
      alreadyPresent: "El elemento ya está presente",
      notFound: "Elemento no encontrado",
      inUseByConfiguration: "El elemento aún está en uso por una configuración",
    },
  },
  terminals: {
    createNew: "Crear nueva terminal",
    delete: "Eliminar terminal",
    edit: "Editar terminal",
    singular: "Terminal",
    plural: "Terminales",
    search: "Buscar terminales",
    questions: {
      delete: "¿Realmente deseas eliminar esta terminal?",
    },
    errors: {
      alreadyPresent: "La terminal ya está presente",
      notFound: "Terminal no encontrada",
      inUseByConfiguration: "La terminal aún está en uso por una configuración",
    },
  },
  roofTypes: {
    createNew: "Crear nuevo tipo de techo",
    delete: "Eliminar tipo de techo",
    singular: "Tipo de techo",
    plural: "Tipos de techo",
    search: "Buscar tipos de techo",
    questions: {
      delete: "¿Realmente deseas eliminar este tipo de techo?",
    },
    errors: {
      pleaseSelectRoofType: "Por favor, seleccione un tipo de techo",
    },
  },
  roofCategories: {
    createNew: "Crear nueva categoría de techo",
    delete: "Eliminar categoría de techo",
    singular: "Categoría de techo",
    plural: "Categorías de techo",
    search: "Buscar categorías de techo",
    questions: {
      delete: "¿Realmente deseas eliminar esta categoría de techo?",
    },
    errors: {
      pleaseSelectRoofCategory: "Por favor, seleccione una categoría de techo",
      inUseByRoofType: "La categoría aún está en uso por un tipo de techo",
    },
  },
  roofMaterials: {
    createNew: "Crear nuevo material de techo",
    delete: "Eliminar material de techo",
    singular: "Material de techo",
    plural: "Materiales de techo",
    search: "Buscar materiales de techo",
    questions: {
      delete: "¿Realmente deseas eliminar este material de techo?",
    },
  },
  materials: {
    createNew: "Crear nuevo material",
    delete: "Eliminar material",
    singular: "Material",
    plural: "Materiales",
    search: "Buscar materiales",
    questions: {
      delete: "¿Realmente deseas eliminar este material?",
    },
  },

  roofSubstructures: {
    createNew: "Crear nueva subestructura de techo",
    delete: "Eliminar subestructura de techo",
    singular: "Subestructura de techo",
    single: "Subestructura de techo",
    plural: "Subestructuras de techo",
    search: "Buscar subestructuras de techo",
    questions: {
      delete: "¿Realmente deseas eliminar esta subestructura de techo?",
    },
  },
  sheetMaterials: {
    createNew: "Crear nuevo material de chapa",
    delete: "Eliminar material de chapa",
    edit: "Editar material de chapa",
    singular: "Material de chapa",
    plural: "Materiales de chapa",
    search: "Buscar materiales de chapa",
    questions: {
      delete: "¿Realmente deseas eliminar este material de chapa?",
    },
  },
  patrolSystems: {
    createNew: "Crear nuevo sistema",
    delete: "Eliminar sistema",
    singular: "Sistema",
    plural: "Sistemas",
    search: "Buscar sistemas",
    questions: {
      delete: "¿Realmente deseas eliminar este sistema?",
    },
  },
  patrolSystemMappings: {
    createNew: "Crear nueva asignación de sistema",
    delete: "Eliminar asignación de sistema",
    edit: "Editar asignación de sistema",
    singular: "Asignación de sistema",
    plural: "Asignaciones de sistema",
    search: "Buscar asignaciones de sistema",
    questions: {
      delete: "¿Realmente deseas eliminar esta asignación de sistema?",
    },
  },
  systemNormatives: {
    createNew: "Crear nueva normativa de sistema",
    delete: "Eliminar normativa de sistema",
    edit: "Editar normativa de sistema",
    singular: "Normativa de sistema",
    plural: "Normativas de sistema",
    search: "Buscar normativas de sistema",
    questions: {
      delete: "¿Realmente deseas eliminar esta normativa de sistema?",
    },

    errors: {
      normativeAlreadyPresent: "La normativa seleccionada ya está asociada al sistema.",
    },
  },
  uprightSpanMappings: {
    createNew: "Crear nueva asignación de luz de montante",
    delete: "Eliminar asignación de luz de montante",
    edit: "Editar asignación de luz de montante",
    singular: "Asignación de luz de montante",
    plural: "Asignaciones de luz de montante",
    search: "Buscar asignaciones de luz de montante",
    questions: {
      delete: "¿Realmente desea eliminar esta asignación de luz de montante?",
    },
    errors: {
      alreadyPresent: "Asignación de luz de montante ya presente",
      updateNotAllowed: "No tienes permiso para actualizar esta asignación de luz de montante.",
    },
  },
  uprightMappings: {
    createNew: "Crear nueva asignación de montante",
    delete: "Eliminar asignación de montante",
    edit: "Editar asignación de montante",
    singular: "Asignación de montante",
    plural: "Asignaciones de montante",
    search: "Buscar asignaciones de montante",
    questions: {
      delete: "¿Realmente desea eliminar esta asignación de montante?",
    },
    errors: {
      alreadyPresent: "Asignación de montante ya presente",
    },
  },
  patrolAnchorMappings: {
    createNew: "Crear nueva asignación de anclaje",
    delete: "Eliminar asignación de anclaje",
    edit: "Editar asignación de anclaje",
    singular: "Asignación de anclaje",
    plural: "Asignaciones de anclaje",
    search: "Buscar asignaciones de anclaje",
    questions: {
      delete: "¿Realmente deseas eliminar esta asignación de anclaje?",
    },
  },
  membranes: {
    createNew: "Crear nueva membrana",
    delete: "Eliminar membrana",
    singular: "Membrana",
    plural: "Membranas",
    search: "Buscar membranas",
    questions: {
      delete: "¿Realmente deseas eliminar esta membrana?",
    },
    single: "Membrana",
  },
  patrolSupports: {
    createNew: "Crear nuevo soporte",
    delete: "Eliminar soporte",
    edit: "Editar soporte",
    singular: "Soporte",
    plural: "Soportes",
    search: "Buscar soportes",
    questions: {
      delete: "¿Realmente deseas eliminar este soporte?",
    },
  },
  itemNormativeExclusions: {
    add: "Agregar elemento excluido",
    createNew: "Crear nueva exclusión normativa de elemento",
    delete: "Eliminar exclusión normativa de elemento",
    edit: "Editar exclusión normativa de elemento",
    singular: "Exclusión normativa de elemento",
    plural: "Exclusiones normativas de elemento",
    search: "Buscar exclusiones normativas de elemento",
    questions: {
      remove: "¿Realmente deseas eliminar este elemento excluido?",
    },
    errors: {
      notFound: "Exclusión normativa de elemento no encontrada",
    },
  },
  supportExtensions: {
    createNew: "Crear nueva extensión de soporte",
    delete: "Eliminar extensión de soporte",
    edit: "Editar extensión de soporte",
    singular: "Extensión de soporte",
    plural: "Extensiones de soporte",
    search: "Buscar extensiones de soporte",
    questions: {
      delete: "¿Realmente deseas eliminar esta extensión de soporte?",
    },
  },
  supportExtras: {
    createNew: "Crear nuevo extra de soporte",
    delete: "Eliminar extra de soporte",
    edit: "Editar extra de soporte",
    singular: "Extra de soporte",
    plural: "Extras de soporte",
    search: "Buscar extras de soporte",
    questions: {
      delete: "¿Realmente deseas eliminar este extra de soporte?",
    },
  },
  supportOptionals: {
    createNew: "Crear nuevo soporte opcional",
    delete: "Eliminar soporte opcional",
    edit: "Editar soporte opcional",
    singular: "Soporte opcional",
    plural: "Soportes opcionales",
    search: "Buscar soportes opcionales",
    questions: {
      delete: "¿Realmente deseas eliminar este soporte opcional?",
    },
  },
  anchorPoints: {
    addNew: "Agregar nuevos puntos de anclaje",
    singular: "Punto de anclaje",
    plural: "Puntos de anclaje",
    delete: "Eliminar punto de anclaje",
    hide: "Ocultar puntos de anclaje",
    show: "Mostrar puntos de anclaje",
    questions: {
      delete: "¿Realmente deseas eliminar el punto de anclaje seleccionado?",
    },
  },
  accessPoints: {
    addNew: "Agregar nuevos puntos de acceso",
    singular: "Punto de acceso",
    delete: "Eliminar punto de acceso",
    questions: {
      delete: "¿Realmente deseas eliminar el punto de acceso seleccionado?",
    },
  },
  lifeLines: {
    draw: "Dibujar línea de vida",
    singular: "Línea de vida",
    plural: "Líneas de vida",
    delete: "Eliminar línea de vida",
    hide: "Ocultar líneas de vida",
    show: "Mostrar líneas de vida",
    questions: {
      deleteEdge: "¿Realmente deseas eliminar el segmento seleccionado?",
      deleteNode: "¿Realmente deseas eliminar el punto de intersección seleccionado?",
    },
    errors: {
      creatingCrossIntersectionsNotAllowed: "No está permitido crear una intersección en cruz de cuatro puntos.",
      loopsNotAllowed: "El sistema seleccionado no permite bucles.",
      intersectionsNotAllowed: "El sistema seleccionado no permite intersecciones de 3 vías.",
      systemDoesNotAllowMoreThanXCorners: (maxCorners: number) =>
        `El sistema seleccionado no permite más de ${maxCorners} esquinas`,
    },
  },
  clampings: {
    createNew: "Crear nueva fijación",
    edit: "Editar fijación",
    delete: "Eliminar fijación",
    singular: "Fijación",
    plural: "Fijaciones",
    search: "Buscar fijaciones",
    questions: {
      delete: "¿Realmente deseas eliminar esta fijación?",
    },
    errors: {
      notFound: "Fijación no encontrada",
      inUseByConfiguration: "La fijación aún está en uso por una configuración",
    },
  },
  patrolCurveIntermediates: {
    singular: "Curva/Intermedio",
    plural: "Curvas/Intermedios",
    createNew: "Crear nueva curva/intermedio",
    delete: "Eliminar curva/intermedio",
    edit: "Editar curva/intermedio",
    search: "Buscar curvas/intermedios",
    questions: {
      delete: "¿Realmente deseas eliminar esta curva/intermedio?",
    },
  },
  normativeVersions: {
    singular: "Versión normativa",
    plural: "Versiones normativas",
    add: "Agregar versión normativa",
    createNew: "Crear nueva versión normativa",
    errors: {
      atLeastOneSystemRequired: "Se requiere al menos un sistema.",
    },
  },
};

export default es;
